import {
  FGMaskInput,
  FGSelectInput,
  FGTextAreaInput,
  FGTextInput,
  FieldGroup,
  FieldSet,
} from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { EHealthValueType, TransientDysplasiaDto } from "../../api";
import { useTl } from "../../hooks";
import { useReferential } from "../../hooks/useReferential";
import { ETLCodes } from "../../locales";

const StyledFieldSet = styled(FieldSet)`
  font-size: 1rem !important;
  > * {
    font-size: 1rem !important;
  }
`;

export interface IDysplasiaEvaluationProps {
  data: TransientDysplasiaDto;
  upperIndex: number;
  index: number;
  isRefused: boolean;
  readonly?: boolean;
  isComission?: boolean;
  dysplasiaRequestId?: number;
  dysplasiaTypeId?: number;
}

export const DysplasiaEvaluation: React.FunctionComponent<IDysplasiaEvaluationProps> = ({
  data,
  index,
  upperIndex,
  isRefused,
  readonly = false,
  dysplasiaTypeId,
  dysplasiaRequestId,
}) => {
  const { t } = useTl();

  const [characValues, cvloading] = useReferential((a) =>
    a.getHealthValues(data?.characteristicId)
  );

  return (
    <>
      <StyledFieldSet title={data.characteristicName}>
        <FieldGroup>
          {data?.type === EHealthValueType.ValueList ? (
            <FGSelectInput
              name={`transientDysplasiaTypes[${upperIndex}].transientDysplasias[${index}].healthValueId`}
              label={t(ETLCodes.Value)}
              items={characValues}
              loading={cvloading}
              readonly={readonly}
              disabled={isRefused}
            />
          ) : data?.type === EHealthValueType.Numeric ? (
            <FGMaskInput
              name={`transientDysplasiaTypes[${upperIndex}].transientDysplasias[${index}].numericValue`}
              label={t(ETLCodes.Value)}
              readonly={readonly}
              disabled={isRefused}
              cleaveOptions={{
                numeral: true,
              }}
            />
          ) : (
            <FGTextInput
              name={`transientDysplasiaTypes[${upperIndex}].transientDysplasias[${index}].alphaValue`}
              label={t(ETLCodes.Value)}
              readonly={readonly}
              disabled={isRefused}
            />
          )}
          <FGTextAreaInput
            name={`transientDysplasiaTypes[${upperIndex}].transientDysplasias[${index}].otherRemark`}
            label={t(ETLCodes.Remark)}
            readonly={readonly}
            disabled={isRefused}
          />
        </FieldGroup>
      </StyledFieldSet>
    </>
  );
};
